/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.0.9 GR130.gltf --transform
*/

import React, { useRef } from 'react';
import { useGLTF } from '@react-three/drei';

import GR130Model from './GR130-transformed.glb';

export default function Model(props) {
	const { nodes, materials } = useGLTF(GR130Model);
	const color = props.color;

	return (
		<group
			{...props}
			dispose={null}
			scale={100}
			// rotation={[-Math.PI / 2, 0, 0]}
		>
			<mesh
				geometry={nodes.Part_1.geometry}
				material={materials['0.615686_0.811765_0.929412_0.000000_0.000000']}
			/>
		</group>
	);
}

useGLTF.preload('/GR130-transformed.glb');
